//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sortBy from 'lodash.sortby'
import { LANGUAGE_FLAG_IMGS, LEGISLATION_FLAG_IMGS } from '~/utils/runtimeConstants'
import { BUILD_COUNTRIES_DICT, legalHubArticleListExcludedFields, legalHubArticleExcludedTypes } from '~/utils/constants'
import { meta } from '~/utils/meta'
import blokMixin from '~/mixins/blok'
import { isSafe } from '~/utils/url'

// NOTE: also see BlokProseRelatedTemplate!

const parseYoutubeDuration = (duration) => {
  const hours = duration.match(/(\d+)H/)
  const minutes = duration.match(/(\d+)M/)
  const seconds = duration.match(/(\d+)S/)

  return {
    minutes: parseInt(minutes[1]) + (hours ? parseInt(hours[1]) * 60 : 0),
    seconds: seconds ? parseInt(seconds[1]) : 0
  }
}

export default {
  mixins: [blokMixin],
  provide () {
    return {
      // We need to pass that using function to get fresh values
      // as provide is not reactive in Vue2
      getTemplate: () => this.template
    }
  },
  data () {
    return {
      template: null,
      videos: [],
      relatedTemplates: [],
      showCreateContractModal: false,
      customPageBlok: null,
    }
  },
  async fetch () {
    await this.loadTemplate()
  },
  head () {
    const ogText = this.template?.metaTitle || this.template?.name

    return meta({
      title: this.template?.metaTitle || this.template?.name,
      description: this.template?.metaDescription || this.template?.shortDescription,
      canonical: this.template ? this.$url.template(this.template.id, this.template.slug) : null,
      ogImageText: ogText?.length <= 65 ? ogText : null
    })
  },
  computed: {
    blokLayout () {
      return this.blok.body[0]
    },
  },
  mounted () {
    if (this.$route.query._preview || this.$route.query._storyblok) {
      this.loadTemplate()
    }
  },
  methods: {
    async loadTemplate () {
      // Fetch custom storyblok page if exists
      try {
        const country = BUILD_COUNTRIES_DICT[this.$country.current.countryCode]
        this.customPageBlok = await this.$sb.get(`cdn/stories${country.templatePrefix}/templates/${this.$route.params.templateId}`).then(r => r.data.story.content)
      } catch (e) {}

      const previewUrl = isSafe(this.$route.query.previewUrl) ? this.$route.query.previewUrl : null

      // For now we fetch related articles both from the API and from Storyblok. Eventually SB will be the only source of articles, so when articles are migrated into SB, you can remove this variable and just read articles directly from SB only.
      let relatedArticlesBySlug = {}

      try {
        this.template = await this.$api.getTemplate(this.$route.params.templateId, previewUrl, {
          include: 'categories,articles'
        }).then((r) => {
          const t = r.data.data

          for (const x of t.relationships?.articles?.data || []) {
            const article = r.data.included.find(y => y.id === x.id && y.type === x.type)
            relatedArticlesBySlug[article.attributes.slug] = {
              id: article.id,
              title: article.attributes.title,
              slug: article.attributes.slug
            }
          }

          return {
            id: t.id,
            name: t.attributes.name,
            contractName: t.attributes.contractName,
            h1: t.attributes.h1,
            slug: t.attributes.slug,
            updatedAt: t.attributes.updatedAt,
            shortDescription: t.attributes.shortDescription,
            metaTitle: t.attributes.metaTitle,
            metaDescription: t.attributes.metaDescription,
            descriptionHtml: t.attributes.descriptionHtml,
            unitPrice: t.attributes.unitPrice,
            unitPriceWithTax: t.attributes.unitPriceWithTax,
            language: t.attributes.language,
            languageFlagSrc: LANGUAGE_FLAG_IMGS[t.attributes.language],
            legislations: t.attributes.jurisdictions.map(j => ({ ...j, flagSrc: LEGISLATION_FLAG_IMGS[j.code] })),
            videoIds: t.attributes.videoIds || [],
            clientTypes: t.attributes.clientTypes.sort().reverse(), // force company first ["client", "company"]
            createInAccountUrl: `${this.$config.appUrl}/2/template/${t.id}?create=true`,
            categories: (t.relationships?.categories?.data || []).map((c) => {
              const category = r.data.included.find(i => i.id === c.id && i.type === c.type)
              return {
                id: category.id,
                name: category.attributes.name,
                url: this.$url.templateCategory(category.id, category.attributes.slug)
              }
            }),
            relatedTemplates: [],
            relatedArticlesLinks: t.attributes.relatedArticlesLinks,
            articles: [],
            videos: [],
          }
        })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e, 'template id: ' + this.$route.params.templateId)
        this.$nuxt.error({ statusCode: 404, message: 'Template not found' })
        return
      }

      // NOTE: Also see BlokProseRelatedTemplate!
      // Fetch youtube video data
      if (this.template.videoIds.length) {
        try {
          const url = `https://youtube.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${this.template.videoIds.join(',')}&key=${this.$config.youtubeApiKey}`
          this.template.videos = await this.$axios.get(url).then(r => r.data.items.map(v => ({
            id: v.id,
            title: v.snippet.title,
            thumbnail: v.snippet.thumbnails.high,
            duration: parseYoutubeDuration(v.contentDetails.duration)
          })))
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch youtube information for template videos: ' + this.template.id)
        }
      }

      const related = await this.$api.getRelatedTemplatesForTemplate(this.$route.params.templateId).then(r => r.data.data.map(t => ({
        id: t.id,
        name: t.attributes.name,
        url: this.$url.template(t.id, t.attributes.slug)
      })))

      this.template.relatedTemplates = sortBy(related, r => r.name)

      // Fetch related articles from storyblok

      let legalHubBasePath = null
      // Don't crash if visiting an unsupported country code, just don't show related SB articles
      try {
        legalHubBasePath = this.$url.articlesIndex().substring(1)
      } catch (e) {}

      if (legalHubBasePath) {
        const sbParams = {
          is_startpage: 0,
          filter_query: {
            component: { not_in: legalHubArticleExcludedTypes },
          },
          excluding_fields: legalHubArticleListExcludedFields,
          page: 1,
          per_page: 20,
          sort_by: 'published_at:desc',
        }

        // If the template has explicit storyblok article linkings set, favor them over over everything else.
        // In the future we can use just this and remove all other related article fetching logic.
        if (this.template.relatedArticlesLinks) {
          // Clear the article linkings returned by our public API.
          relatedArticlesBySlug = {}

          // We need just the last part (the slug of the article) from the related article links. If a slug is malformed it will just get ignored by SB.
          const articleSlugsStr = this.template.relatedArticlesLinks
            .map(x => `${legalHubBasePath}/${x.split('/').pop()}`)
            .join(',')
          sbParams.by_slugs = articleSlugsStr
        // If the template has no explicit article linkings, include storyblok articles that reference the template, in addition to the articles returned by our public API.
        } else {
          // Not very exact, but works
          sbParams.filter_query.related_templates = { like: `*${this.template.id}*` }
        }

        const storiesRes = await this.$sb.list(legalHubBasePath, sbParams)

        for (const story of storiesRes.data.stories) {
          relatedArticlesBySlug[story.slug] = {
            id: story.uuid,
            title: story.content.title,
            slug: story.slug,
          }
        }
      }

      this.template.articles = sortBy(Object.values(relatedArticlesBySlug), r => r.title)
    },
    createContract () {
      this.$gtm.push({
        event: 'create_contract_clicked',
        template_id: this.template.id,
        has_workspace: !!this.$store.state.workspace,
      })
      this.$ph.capture('create_contract_clicked', {
        template_id: this.template.id,
        has_workspace: !!this.$store.state.workspace,
      })

      // If logged in user, redirect directly to the app for creating the contract
      if (this.$store.state.workspace) {
        location.href = this.template.createInAccountUrl
        return
      }

      this.showCreateContractModal = true
    }
  },
  fetchKey (getCounter) {
    return `_template:${this.$route.params.templateId}:${getCounter('template-page')}`
  }
}
